import { render, staticRenderFns } from "./SendCredentialsModal.vue?vue&type=template&id=c6a4726a&"
import script from "./SendCredentialsModal.vue?vue&type=script&lang=js&"
export * from "./SendCredentialsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports